module.exports = __webpack_public_path__ + "assets/delete_success_female.svg?v=7206a636553a6779ad42c28d5dfe8dfd";